import { usePromotion } from '@mc/promo-utils'
import { useStaticData } from '@mc/static-data-react'

// Mirrored server-side in trackPen7562BackendEV — both gates have to stay in step.
export const useExperimentCriteria = (): boolean => {
  const { isPromotionOn } = usePromotion()
  const { isLoggedIn } = useStaticData<{ isLoggedIn: boolean }>()

  return isPromotionOn && !isLoggedIn
}
